import "./Mensaje.css";
import HeaderModal from "../headerModal/headerModal";

const Mensaje = ({ titulo, textoNegrita, texto, dissmiss, danger }) => {
  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />

      {(texto || textoNegrita) && (
        <div className="ptur-modalBody-mensaje">
          {textoNegrita && (
            <h3 className="rb16m c-latex10">
              {textoNegrita === "" ? "Error inesperado." : textoNegrita}
            </h3>
          )}
          {texto && (
            <h3 className="rb16t c-latex10">{texto === "" ? "" : texto}</h3>
          )}
        </div>
      )}
    </>
  );
};

export default Mensaje;
